// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ✅ Suppress any idle or background Firebase rejections
window.addEventListener("unhandledrejection", (event) => {
  // Log once, quietly
  if (process.env.NODE_ENV === "development") {
    console.warn("Suppressed unhandled rejection:", event.reason);
  }
  event.preventDefault();
});

// ✅ Catch global window errors (rare in Firebase)
window.addEventListener("error", (event) => {
  if (process.env.NODE_ENV === "development") {
    console.warn("Suppressed window error:", event.message);
  }
  event.preventDefault();
});

// ⚙️ Render app normally (no StrictMode — avoids double render & promise spam)
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Optional: Keep performance logging if you want
reportWebVitals();
